export enum sectionIds {
  Welcome = 'welcome',
  Work = 'work',
  Projects = 'projects',
  Contact = 'contact',
  Teaching = 'teaching',
}

export enum PageIds {
  Home = 'home',
  Teaching = 'teaching',
}
